import React, { memo, useMemo } from 'react';
import { InventoryEntities } from 'client/data/models/inventory';
import { VdpModule } from 'site-modules/shared/components/inventory/vdp-module/vdp-module';
import { WarrantyItem } from 'site-modules/shared/components/inventory/warranty-module/warranty-item/warranty-item';
import { sortWarranty } from 'site-modules/shared/utils/inventory/warranty';
import { MAX_COLLAPSED_WARRANTY_COUNT } from 'site-modules/shared/constants/inventory/warranty';
import { Accordion } from 'site-modules/shared/components/inventory/accordion/accordion';
import { ViewMore } from 'site-modules/shared/components/inventory/view-more/view-more';

import './warranty-details-new.scss';

export const WarrantyDetailsNew = memo(props => {
  const { warranty } = props;
  const sortedWarranty = useMemo(() => sortWarranty(warranty), [warranty]);

  const renderWarrantyItem = warrantyItem => <WarrantyItem warrantyItem={warrantyItem} key={warrantyItem.id} />;

  return (
    <VdpModule className="bg-white warranty-details-new px-1_5 py-0_5" withIndents={false}>
      <Accordion>
        <ul className="warranty-details-new-list list-unstyled mb-0">
          {sortedWarranty.slice(0, MAX_COLLAPSED_WARRANTY_COUNT).map(renderWarrantyItem)}
        </ul>
        {sortedWarranty.length > MAX_COLLAPSED_WARRANTY_COUNT && (
          <ViewMore
            className="warranty-details-new-more my-1"
            expandedSummary="Hide all manufacturer warranties"
            collapsedSummary="All manufacturer warranties"
          >
            <ul className="warranty-details-new-list list-unstyled mb-0">
              {sortedWarranty.slice(MAX_COLLAPSED_WARRANTY_COUNT).map(renderWarrantyItem)}
            </ul>
          </ViewMore>
        )}
      </Accordion>
    </VdpModule>
  );
});

WarrantyDetailsNew.propTypes = {
  warranty: InventoryEntities.Warranty.isRequired,
};

WarrantyDetailsNew.displayName = 'WarrantyDetailsNew';
